import React from 'react';
import { Send } from 'lucide-react';

const ChatInput = ({ type, setType, handleKey, sendMessage , sending}) => {
  return (
    <div className="wc-input">
      <input
        value={type}
        onChange={e => setType(e.target.value)}
        onKeyDown={handleKey}
        placeholder="Type message..."
      />
      <button
  onClick={sendMessage}
  disabled={sending}
>
  <Send size={18} />
</button>
    </div>
  );
};

export default ChatInput;